export { default as YandexMetrika } from "./YandexMetrika";
export { default as useMetrika } from "./useMetrika";
